import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';


@Injectable()
export class LocalStorageProvider {

  constructor(public storage: Storage) {
  }

  storageSave(table, data) {
    this.storage.ready().then(() => {
      this.storage.set(table, JSON.stringify(data));
    });
  }

  storageGet(table) {
    return this.storage.get(table);
  }

}



// WEBPACK FOOTER //
// ./src/providers/local-storage.ts